import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { injectIntl } from 'react-intl';

const MonthSelect = ({ label, value, min, onChange, intl }) => {
  const [extraMonths, setExtraMonths] = useState(0);
  const first = moment(min, 'YYYY-MM').startOf('month');
  const count = Math.max(24, moment(value, 'YYYY-MM').diff(first, 'months') + 1) + extraMonths;

  return (
    <label>
      {label}
      <select
        value={value}
        onChange={(event) => {
          if (event.target.value === 'more') setExtraMonths((previous) => previous + 24);
          else onChange(event.target.value);
        }}
      >
        {Array.from({ length: count }, (_, index) => {
          const month = first.clone().add(index, 'months');
          return (
            <option key={month.format('YYYY-MM')} value={month.format('YYYY-MM')}>
              {intl.formatDate(month.toDate(), { month: 'long', year: 'numeric' })}
            </option>
          );
        })}
        <option value="more">{intl.formatMessage({ id: 'lowestFareFinder.moreMonths' })}</option>
      </select>
    </label>
  );
};

MonthSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  min: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(MonthSelect);
